export default function CitySelect()
{
    return (<div className="dropdown header__city">
        <button className="d-flex align-items-center dropdown-toggle bs-link gap-1" type="button"
                id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
            <span>Москва</span>
        </button>
        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <li><a className="active dropdown-item" href="#" data-value="Action">Москва</a></li>
            <li><a className="dropdown-item" href="#" data-value="Another action">Питер</a></li>
            <li><a className="dropdown-item" href="#" data-value="Something else">Город-65</a></li>
        </ul>
    </div>)
}